import { render, staticRenderFns } from "./dialog-set-removed.vue?vue&type=template&id=483a2f9e&"
import script from "./dialog-set-removed.vue?vue&type=script&lang=js&"
export * from "./dialog-set-removed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports